import { fg } from '@atlassian/jira-feature-gating';

const isGsnBoardUrlFixEnabled = {
	get(): boolean {
		return fg('hsbc-23_gsn-board-url-fix');
	},
};

export default isGsnBoardUrlFixEnabled;
